// Module
var code = `<div class="contents" ng-transclude></div> <i class="fa-solid fa-search absolute left-[calc(100%+1px)] top-1/2 -translate-y-1/2 whitespace-nowrap cursor-pointer opacity-50 md:opacity-0 md:group-hover/search-icon-action:opacity-50" title="{{ 'cm_search' | translate }}" ng-click="\$ctrl.handleSearch(\$event)"></i> `;
// Exports
export default code;